/* eslint-disable import/prefer-default-export */
import { TSchema } from '../components/roas/SchemasProvider';

export const getListNameByPropName = (schema: TSchema): Record<string, string> => {
  // { [propertyName]: [listName] }
  const propsByListName: Record<string, string[]> = schema.oneOf ?? {};
  return Object.entries(propsByListName).reduce(
    (accum, [listName, values]) => {
      values.forEach((value) => {
        // eslint-disable-next-line no-param-reassign
        accum[value] = listName;
      });
      return accum;
    },
    {} as Record<string, string>,
  );
};
